import { useEffect, useState } from "react";
import { MessageSquare, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

const FALLBACK_INVITE = "https://discord.gg/ocedogs";

const DiscordCard = ({ className = "" }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/discord/stats").then((r) => alive && setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const invite = d?.invite || FALLBACK_INVITE;
  const online = d?.online;
  const members = d?.members;

  return (
    <div data-testid="discord-card" className={`relative overflow-hidden glass tactical-frame border border-[#5865F2]/40 p-5 ${className}`}>
      <div className="absolute -right-6 -top-8 w-40 h-40 rounded-full bg-[#5865F2]/15 blur-2xl pointer-events-none" />
      <div className="relative flex items-center gap-4">
        <img src="/oce-dogs-logo.webp" alt="OCE DOGS" className="h-14 w-auto shrink-0 drop-shadow-[0_0_10px_rgba(212,169,74,0.3)]" />
        <div className="min-w-0 flex-1">
          <div className="overline text-[9px] text-[#8b93f7]"><MessageSquare className="inline w-3 h-3 mr-1" /> Community Discord</div>
          <h3 className="font-heading text-lg font-black uppercase leading-none mt-1 truncate" data-testid="discord-server-name">{d?.name || "OCEDOGS - AU/NZ"}</h3>
          <div className="mt-1.5 flex items-center gap-3 font-mono text-[11px]">
            {online != null ? (
              <span className="inline-flex items-center gap-1.5 text-[#2ECC71]" data-testid="discord-online">
                <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#2ECC71] opacity-60" /><span className="relative inline-flex rounded-full h-2 w-2 bg-[#2ECC71]" /></span>
                {online.toLocaleString()} online
              </span>
            ) : (
              <span className="inline-flex items-center gap-1.5 text-[#64748B]"><span className="w-2 h-2 rounded-full bg-[#64748B]" /> live</span>
            )}
            {members != null && <span className="text-[#94A3B8]" data-testid="discord-members">{members.toLocaleString()} members</span>}
          </div>
        </div>
      </div>
      <a
        href={invite}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="discord-join-btn"
        className="relative mt-4 w-full flex items-center justify-center gap-2 bg-[#5865F2] hover:bg-[#6774f5] text-white font-stencil font-black uppercase text-sm py-2.5 tactical-frame-sm transition-colors"
      >
        <MessageSquare className="w-4 h-4" /> Join our Discord <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
};

export default DiscordCard;
